
import React from 'react'
import {connect} from "react-redux";
import {servidor, servicioRestfulCompleto} from "../Configuracion";
import {
    CELLTIPO_CADENA,
    CELLTIPO_ENTERO,
    CELLTIPO_FOREIGN,
} from "../../framework2/ej2/UI/TiposCeldas";
import "../resources/css/encabezado.css";
import "../resources/css/selectorperiodo.css";
import {CAMPOTIPO_CADENA} from "../../framework2/ej2/UI/TiposCampos";
import Formulario from "../../framework2/ej2/UI/Formulario";
import {getElementoConfigNombre, getGridConfigNombre} from "../../framework2/ej2/utils/CrudUtilsJPA";
import {BOTONERA_REFRESCAR} from "../../framework2/ej2/UI/FormularioBotonera";

class Historia extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
        }

        this.generarGridConfig(props);
        this.generarElementoConfig(props);
    }

    componentDidMount() {

    }





    render() {
        return (
            <div>

            </div>
        )
    }

}

Historia.propTypes = {

}

const mapStateToProps = function(state) {
    return {
        auth: state.auth,
    }
}
export default connect(mapStateToProps)(Historia);



